export const SKIP_SECONDS = 5;

export const SKIP_INDICATOR_SESSION_TIMEOUT_MILLISECONDS = 2500;
export const SKIP_INDICATOR_ANIMATION_DURATION_MILLISECONDS = 300;
